import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FaqItem from './FaqItem';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
  faqContainer: {
    backgroundColor: '#022639',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    padding: '2.25em',
    paddingTop: '1.75em',
    paddingBottom: '2.4375em',
    marginTop: '4.375em',
    marginBottom: '4.25em',
  },
  faqContainerMobile: {
    backgroundColor: '#022639',
    maxWidth: 448,
    display: 'flex',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    padding: '2.0625em',
    paddingLeft: '2.25em',
    paddingRight: '2.25em',
    marginBottom: '4.25em',
  },
  title: {
    fontSize: '2.125em',
    fontWeight: 'bold',
    letterSpacing: '0.0358em',
    lineHeight: 1.353,
    color: 'white'
  },
  faqInnerContainer: {
    display: 'flex',
  },
  faqInnerContainerMobile: {
    display: 'flex',
    alignItems: "center"
  },
  hidden: {
    display: 'none'
  },
  moreButton: {
    fontFamily: 'Roboto',
    marginTop: '2.75em',
    letterSpacing: '0.031em'
  },
});

interface FaqItemProps {
  title: string;
  content: string;
}

interface FaqContainerProps {
  items: FaqItemProps[];
}

interface MobileViewProps {
  isMobileDevice: boolean | undefined;
}

type Props = MobileViewProps & FaqContainerProps

class FaqContainer extends React.Component<WithStyles & Props, { open: boolean; }> {
  constructor(props: WithStyles & Props) {
    super(props);
    this.state = {
      open: false
    };
  }

  public render() {
    const {
      classes,
      items
    } = this.props;
    const { open } = this.state;
    const buttonLabel = open ? localizations.faqContainer.hideQuestions : localizations.faqContainer.moreQuestions;
    return (
      <Grid item container direction="column" alignItems="center" className={classes.faqContainer}>
        <Grid item className={classes.title}>{localizations.faqContainer.frequentlyAskedQuestions}</Grid>
        {this.props.isMobileDevice === false ?
          <Grid item container>
            {items.slice(0, 3).map((item, index) => (
              <FaqItem key={`faq_item_${index}`} title={item.title} content={item.content} />
            ))}
          </Grid> :
          <Grid item container>
            {items.slice(0, 1).map((item, index) => (
              <FaqItem key={`faq_item_${index}`} title={item.title} content={item.content} />
            ))}
          </Grid>}
        {items.length > 3 ? (
          <React.Fragment>
            <Grid item container className={open ? (this.props.isMobileDevice === false ? classes.faqInnerContainer : classes.faqInnerContainerMobile) : classes.hidden}>
              {items.slice(3).map((item, index) => (
                <FaqItem key={`faq_item_${index}`} title={item.title} content={item.content} />
              ))}
            </Grid>
            <Grid item>
              <Button variant="contained" color="secondary" className={classes.moreButton} onClick={this.toggleOpen}>
                {buttonLabel}
              </Button>
            </Grid>
          </React.Fragment>
        ) : null}
      </Grid>
    );
  }

  private toggleOpen = () => this.setState({ open: !this.state.open });
}

export default withStyles(styles)(FaqContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/FaqContainer.tsx